import { combineReducers } from 'redux';

import {
  EMPLOYEE_PIN_SET_SUBMITTING,
  EMPLOYEE_PIN_SET_ALLOWED_FIELDS,
  EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL,
  EMPLOYEE_PIN_SET_OUTLETS_EMPLOYEES,
} from '../../actions/employees/pin/constants';
import createReducer from '../../utils/createReducer';

const allowedFields = createReducer([], {
  [EMPLOYEE_PIN_SET_ALLOWED_FIELDS]: (draft, { payload }) => [
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    ...payload.allowedFields,
  ],
});

const saveAppPermissionModal = createReducer(
  {
    message: '',
  },
  {
    [EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL]: (draft, { payload }) => ({
      // @ts-expect-error ts-migrate(2698) FIXME: Spread types may only be created from object types... Remove this comment to see the full error message
      ...payload,
    }),
  }
);

const showSaveAppPermissionModal = createReducer(false, {
  [EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL]: () => true,
  [EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL]: () => false,
});

const submitting = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [EMPLOYEE_PIN_SET_SUBMITTING]: (draft, { payload }) => payload.submitting,
});

const outletsEmployees = createReducer([], {
  [EMPLOYEE_PIN_SET_OUTLETS_EMPLOYEES]: (draft, { payload }) => [
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    ...payload.outletsEmployees,
  ],
});

export default combineReducers({
  allowedFields,
  saveAppPermissionModal,
  showSaveAppPermissionModal,
  submitting,
  outletsEmployees,
});
